import { combineReducers } from 'redux';
import login from './login/reducer';
import lang from './languages/reducer';
import sidebar from './sidebar/reducer';
import entities from './entities/reducer';
import locations from './locations/reducer';
import regions from './regions/reducer';
import currencies from './currencies/reducer';
import equipmentOptions from './equipment-options/reducer';
import map from './map/reducer';
import filters from './filterbar/reducer';

const appState = combineReducers({
  login,
  lang,
  sidebar,
  entities,
  locations,
  regions,
  currencies,
  equipmentOptions,
  map,
  filters
});

export default appState;

export type AppState = ReturnType<typeof appState>;
